import React, { useCallback } from 'react'
import styles from './DropZone.module.css'

export default function DropZone({ onFileSelect, error, onRetry }) {
  const handleDragOver = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
  }, [])

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      const files = e.dataTransfer.files
      if (files && files.length > 0) {
        onFileSelect(files[0])
      }
    },
    [onFileSelect]
  )

  const handleChange = useCallback(
    (e) => {
      const files = e.target.files
      if (files && files.length > 0) {
        onFileSelect(files[0])
      }
    },
    [onFileSelect]
  )

  return (
    <div
      className={[styles.zone, error && styles.zoneError].filter(Boolean).join(' ')}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <input
        id="file-input"
        type="file"
        className={styles.input}
        onChange={handleChange}
        aria-label="Upload file"
      />
      <label htmlFor="file-input" className={styles.label}>
        <span className={styles.icon} aria-hidden="true">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
        <span className={styles.text}>
          <span className={styles.primary}>Click to upload</span> or drag and drop
        </span>
        <span className={styles.hint}>JPG, PNG, HEIC, PDF up to 10MB</span>
      </label>
      {error && (
        <p className={styles.error} role="alert">
          {error}
          <button className={styles.retry} onClick={onRetry} type="button">
            Try again
          </button>
        </p>
      )}
    </div>
  )
}
